// extracted by mini-css-extract-plugin
export default {"dropzone":"audioDropzone_dropzone__IHJku","cancel":"audioDropzone_cancel__M9rAk"};